// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Warning = React.forwardRef(function Warning(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Warning" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5027 2.31963C11.1962 1.22679 12.9137 1.22679 13.6071 2.31963L23.0025 20.0155C23.7013 21.1169 22.8372 22.5 21.4503 22.5H2.5497C1.1628 22.5 0.298676 21.1169 0.997495 20.0155L10.5027 2.31963ZM13.875 18.375C13.875 19.4105 13.0355 20.25 12 20.25C10.9645 20.25 10.125 19.4105 10.125 18.375C10.125 17.3395 10.9645 16.5 12 16.5C13.0355 16.5 13.875 17.3395 13.875 18.375ZM13.5 7.5H10.5V14.25H13.5V7.5Z", fill: "currentColor" }))));
});
Warning.displayName = 'Warning';
export default Warning;
